<template>
  <el-dialog
    custom-class="ai-warning-dialog"
    :visible.sync="visible"
    :before-close="onClose"
    center
    width="50%"
  >
    <div class="dialogtitle">
      <div class="titlebg">
        <img src="../../assets/警告@2x.png" alt="" />
        <span> 请确认以下告警 </span>
      </div>
    </div>
    <div class="dialogtable">
      <el-table
        :data="dataList"
        style="width: 100%"
        max-height="350"
      >
        <el-table-column prop="module_name" label="告警模块" align="center" min-width="180"></el-table-column>
        <el-table-column prop="time" label="开始时间" align="center" min-width="180"></el-table-column>
        <el-table-column prop="des" label="当前告警" align="center" min-width="360">
          <template  slot-scope="scope">
            <span class="warning-des">{{ scope.row.des }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: Array,
      default: () => ([]),
    }
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog.ai-warning-dialog {
  opacity: 1;
  border-radius: 35px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 12px 50px 9px rgba(222, 60, 60, 0.25);

  .el-dialog__body {
    max-height: 900px;
    overflow: auto;
  }

  .dialogtitle {
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;

    .titlebg {
      width: 795px;
      border-radius: 159px;
      background: rgba(254, 236, 234, 1);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 30px;
      height: 26px;
    }

    span {
      font-size: 24px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 58px;
      color: rgba(212, 48, 48, 1);
      text-align: left;
      vertical-align: middle;
    }
  }
}
</style>

<style lang="scss">
.jinyi-home-container {
  .ai-warning-dialog {
    min-height: 500px;

    .dialogtitle .titlebg {
      span {
        font-size: 28px;
      }
    }
    .el-table {
      .cell {
        font-size: 24px;
      }
    }
    .warning-des {
      font-weight: 700;
    }
  }
}
</style>